import LegalPage from "@/pages/legal/LegalPage";

export default function PrivacyPolicyPage() {
  return (
    <LegalPage
      title="Privacy Policy"
      slug="privacy-policy"
      testIdPrefix="legal-privacy"
    />
  );
}
